import { render } from "./OptionTags.vue?vue&type=template&id=2958335a&ts=true"
import script from "./OptionTags.vue?vue&type=script&lang=ts"
export * from "./OptionTags.vue?vue&type=script&lang=ts"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__